import React from "react";
export const getNavLinkComponent = (getNavLink) => React.memo(getNavLink);
//# sourceMappingURL=getNavLinkComponent.js.map